import { applicationEnv, applications } from 'constants/application';

export const isAdminApplication = () =>
  process.env[applicationEnv] ? process.env[applicationEnv] === applications.admin : true;

export const isClientApplication = () => process.env[applicationEnv] === applications.client;
